import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React from "react";
import AllFields from "./AllFields";
import Photos from "./Photos";

const ProductFields = ({ onEmitFields, uploadPhoto, products }) => {
  
  const updateFields = (value: object | null = null) => {
    onEmitFields(value)
  };

    const hasBoxProduct = products.some(product => product.is_box);

  return (
    <Grid container spacing={2}>
      <Grid
        item
        sx={{
          flexBasis: { xs: "100%", md: 364 },
          order: { xs: 100000, md: 0 },
        }}
      >
        <Paper sx={{ padding: 3 }}>
          <Photos uploadPhoto={uploadPhoto} />
        </Paper>
      </Grid>
      <Grid item xs>
        <Paper sx={{ padding: 3 }}>
          <Grid container spacing={3}>
            <AllFields onEmitFields={updateFields} hasBoxProduct={hasBoxProduct} products={products} />
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}

export default ProductFields